import { Box, styled } from '@mui/material';

export const DeveloperName = styled('em')(({ theme }) => ({
  fontSize: '0.75rem',
  display: 'inline',
  color: theme.palette.text.primary,
  fontStyle: 'normal',
  marginLeft: '5px',
  fontWeight: 700,
}));

export const Container = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(4)} 0`,
}));

export const AlertContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
